module.exports = __webpack_public_path__ + "static/media/game-voice-john.e85ba639.png";